import { ChevronRight, Loader2 } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../redux/store";
import { setTopNavNameTitle } from "../../../redux/features/mobileLayout/slice";
import { NgwAvatar } from "../../../components/common";

interface ActorProfileMaster {
    os_emp_account_id?: string;
    employee_name?: string;
    profile_image?: string;
}

interface WhoIsWorkingProps {
    isLoading?: boolean;
    employees?: ActorProfileMaster[];
}

const WhoIsWorking: React.FC<WhoIsWorkingProps> = ({ isLoading = false, employees = [] }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const handleViewAll = () => {
        dispatch(setTopNavNameTitle("Who's Working Now"));
        navigate("/m-view-employees");
    };

    const showLoader = isLoading;
    const employeesToShow = employees;

    return (
        <div className="p-6 rounded-lg border border-gray-300 bg-white mb-4">
            <div className="flex items-center justify-between">
                <h2
                    className="text-xl text-blue-500 leading-none flex items-center"
                    onClick={handleViewAll}
                >
                    Who's Working Now
                </h2>
                <ChevronRight className="w-7 h-7 flex-shrink-0 text-blue-500" onClick={handleViewAll} />
            </div>
            {showLoader ? (
                <div className="flex justify-center py-4">
                    <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
                </div>
            ) : (
                <div className="mt-4 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        {employeesToShow.length > 0 ? (
                            employeesToShow.slice(0, 5).map((worker, index) => (
                                <div key={worker.os_emp_account_id || index} className="relative group">
                                    {/* <img
                                        src={
                                            worker.profile_image ||
                                            "https://devbox.webapph.com/app17/assets/images/noempimg.png"
                                        }
                                        alt={worker.employee_name || "Unknown"}
                                        className="w-14 h-14 rounded-full border border-gray-200"
                                    /> */}
                                    <NgwAvatar
                                        src={worker.profile_image || ""}
                                        name={worker.employee_name || "Unknown"}
                                        className="w-14 h-14 rounded-full border border-gray-200"
                                    />
                                    {/* <span className="absolute left-1/2 bottom-full mb-2 w-auto text-xs px-2 py-1 bg-gray-700 text-white rounded opacity-0 transition-opacity group-hover:opacity-100">
                                        {worker.employee_name || "No Name"}
                                    </span> */}
                                </div>
                            ))
                        ) : (
                            <p className="text-gray-500 text-center">No employees are currently working.</p>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default WhoIsWorking;
